import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20soft%20golden%20and%20coral%20tones%2C%20elegant%20flowing%20lines%2C%20minimal%20geometric%20patterns%2C%20luxurious%20ambient%20atmosphere%2C%20sophisticated%20modern%20design%2C%20smooth%20color%20transitions%2C%20no%20text%20or%20people&width=1600&height=900&seq=hero-bg-xfb&orientation=landscape"
          alt="性福宝导航背景"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-5 leading-tight">
          性福宝导航
        </h1>
        <p className="text-lg md:text-xl text-white/90 mb-3 font-light">
          精选成人资源一站式导航平台
        </p>
        <p className="text-sm md:text-base text-white/70 mb-8 max-w-2xl mx-auto leading-relaxed">
          汇聚海量精选成人内容、娱乐资源及相关服务链接，分类清晰、更新及时、安全可靠
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/video"
            className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-lg hover:bg-primary-600 transition-colors text-sm whitespace-nowrap cursor-pointer"
          >
            <i className="ri-movie-line mr-2"></i>浏览视频平台
          </Link>
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3 bg-white/15 text-white font-medium rounded-lg hover:bg-white/25 transition-colors text-sm whitespace-nowrap cursor-pointer backdrop-blur-sm"
          >
            <i className="ri-information-line mr-2"></i>了解更多
          </Link>
        </div>

        <div className="mt-10 flex items-center justify-center gap-8">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-white">160+</div>
            <div className="text-xs text-white/60 mt-1">精选站点</div>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-white">8</div>
            <div className="text-xs text-white/60 mt-1">分类频道</div>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-white">99.9%</div>
            <div className="text-xs text-white/60 mt-1">服务可用率</div>
          </div>
        </div>
      </div>
    </section>
  );
}